import {Controller} from "@/controllers/Controller";

/**
 * Controller for publication API (ms-marketing) : texte, image, diffusion et résultats d'un sujet sur un réseau
 */
export class PublicationController extends Controller {

    // Toutes les publications du groupe, chacune avec son sujet
    static getTable() {
        return this.requestBuilder("GET", `/marketing/publications/table`, true);
    }

    static get(id) {
        return this.requestBuilder("GET", `/marketing/publications/${id}`, true);
    }

    // Ajoute une publication (un réseau de plus) à un sujet
    static post(body) {
        return this.requestBuilder("POST", `/marketing/publications`, true, body);
    }

    static patch(id, body) {
        return this.requestBuilder("PATCH", `/marketing/publications/${id}`, true, body);
    }

    static schedule(id, body) {
        return this.requestBuilder("PATCH", `/marketing/publications/schedule/${id}`, true, body);
    }

    static unschedule(id) {
        return this.requestBuilder("PATCH", `/marketing/publications/unschedule/${id}`, true);
    }

    // « Marquer publié » : la publication a été faite à la main sur le réseau
    static publish(id, body) {
        return this.requestBuilder("PATCH", `/marketing/publications/publish/${id}`, true, body);
    }

    static unpublish(id) {
        return this.requestBuilder("PATCH", `/marketing/publications/unpublish/${id}`, true);
    }

    // Résultats saisis à la main
    static saveMetrics(id, body) {
        return this.requestBuilder("PATCH", `/marketing/publications/metrics/${id}`, true, body);
    }

    static delete(id) {
        return this.requestBuilder("PATCH", `/marketing/publications/deactivate/${id}`, true);
    }
}
